import { Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { io } from "socket.io-client";
import { getPeopleAheadCount } from "../services/patientRegistrationRequesApi"; // Import API functions
import { useLocation } from "react-router-dom";
import { usePatientContext } from "../context/PatientContext";
import {
  getTokenClinicDoctor,
  getValueFromPatToken,
} from "../utils/commonUtils";

function AppointmentConfirmation() {
  const location = useLocation();
  const preViousState = location?.state ?? {};
  const [peopleAhead, setPeopleAhead] = useState(null);
  const [appointmentNumber, setAppointmentNumber] = useState(null);
  const [showDoctorName, setDoctorName] = useState();

  const { patientAppData, getPatientAppData, savePatientAppData } =
    usePatientContext();

  useEffect(() => {
    const fetchPeopleAhead = async () => {
      const clinicId = localStorage.getItem("clinicId");
      const doctorId = localStorage.getItem("doctorId");
      const patientId = localStorage.getItem("patientId");

      try {
        const data = await getPeopleAheadCount(patientId, doctorId, clinicId);
        setPeopleAhead(data.count);
      } catch (error) {
        console.error(
          "An error occurred while fetching people ahead count:",
          error
        );
      }
    };

    fetchPeopleAhead();

    // Setup WebSocket connection
    const socket = io(process.env.REACT_APP_API_URL);
    const appointment_number = localStorage.getItem("appointmentNumber");
    setAppointmentNumber(appointment_number);

    socket.on("queueUpdated", (data) => {
      fetchPeopleAhead(); // Call fetchPeopleAhead when 'queueUpdated' event is received
    });

    return () => {
      socket.off("queueUpdated");
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    const getClinicAndDoctor = getTokenClinicDoctor();
    setDoctorName(getClinicAndDoctor.doctorName);
  }, []);

  const clinicName = localStorage.getItem("clinicName");

  return (
    <div className="flex flex-col h-[calc(100vh-72px)] items-center justify-center bg-[#ECF1F4]">
      <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 max-w-2xl w-full mx-4">
        <div className="flex flex-col items-center mb-12">
          <img
            src="../images/new_vitalX_logo.svg"
            alt="VitalX Logo"
            className="w-24 h-24 mb-6" // Increased size for logo
          />
          <h1 className="text-3xl md:text-4xl font-semibold text-[#1D4ED8] mb-2">
            Welcome to VitalX
          </h1>
          <h2 className="text-md md:text-lg text-gray-600">
            {" "}
            {clinicName ? clinicName : ""}
          </h2>
        </div>

        <div className="text-center">
          <div className="bg-[#1D4ED8] text-white rounded-full py-4 mb-8 transition-all hover:shadow-md">
            <p className="text-md md:text-lg font-medium">
              Your appointment with <strong>Dr. {showDoctorName}</strong> is
              booked with number <strong>{appointmentNumber}</strong>.
            </p>
          </div>

          <div className="bg-[#1D4ED8] text-white rounded-full py-4 transition-all hover:shadow-md">
            <p className="text-md md:text-lg font-medium">
              You are in Queue - <strong>{peopleAhead}</strong> people ahead of
              you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppointmentConfirmation;
